import { render, staticRenderFns } from "./UseCasePopup.vue?vue&type=template&id=61b5624a"
import script from "./UseCasePopup.vue?vue&type=script&lang=ts"
export * from "./UseCasePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports